<template>
    <b-container>
        <PortalNavbar show="true"></PortalNavbar>
        <section class="list_area row">
        <div class="container">
            <!--<div class="tittle wow fadeInUp">
                <h2>ABOUT US</h2>
               
            </div>-->
            
            <div class="row list_row">
               
                <div class="who_we_area col-md-12">
                    <div class="subtittle">
                        <h2 style="color:#ec5624;">List Of Boards</h2>
                    </div>
                    <br/>
                    <br/>
                   <table class="table table-bordered"> 
                   <thead> 
                   <tr> 
                   		<th>#</th> 
                   		<th>Name of Board</th> 
                   		<th>Contact Details</th> 
                   </tr> 
                   </thead>
                    
                   <tbody> 
                   		<tr> 
                   			<th scope="row">1</th> 
                   			<td>AhmadNagar District Security Guard Board</td> 
                   			<td></td> 
                   		</tr> 
                       <tr> 
                            <th scope="row">2</th>
                            <td>Amravati District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        <tr> 
                            <th scope="row">3</th> 
                            <td>Aurangabad District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        
                        <tr> 
                   			<th scope="row">4</th> 
                   			<td>Brahan Mumbai Security Guard Board</td> 
                   			<td></td> 
                   		</tr> 
                       <tr> 
                            <th scope="row">5</th>
                            <td>Chandrapur District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        <tr> 
                            <th scope="row">6</th> 
                            <td>Dhule District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        
                        <tr> 
                   			<th scope="row">7</th> 
                   			<td>Kolhapur District Security Guard Board</td> 
                   			<td></td> 
                   		</tr> 
                       <tr> 
                            <th scope="row">8</th>
                            <td>Nagpur District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        <tr> 
                            <th scope="row">9</th> 
                            <td>Nashik District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        
                        <tr> 
                   			<th scope="row">10</th> 
                   			<td>Pune District Security Guard Board</td> 
                   			<td></td> 
                   		</tr> 
                       <tr> 
                            <th scope="row">11</th>
                            <td>Raigad District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        <tr> 
                            <th scope="row">12</th> 
                            <td>Ratnagiri District Security Board</td> 
                            <td></td> 
                        </tr> 
                        
                        <tr> 
                   			<th scope="row">13</th> 
                   			<td>Sangali District Security Guard Board</td> 
                   			<td></td> 
                   		</tr> 
                       <tr> 
                            <th scope="row">14</th>
                            <td>Solapur District Security Guard Board</td> 
                            <td></td> 
                        </tr> 
                        
                        
                    </tbody> 
                    </table>
                    
                    
                    
                    <br/>
                   
                </div>
                
                 
            </div>
            
        </div>
    </section>
    </b-container>
</template>

<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>
.list_area .list_row {
  padding-top: 70px;
  padding-bottom: 70px;
}
.list_area .list_row p {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
  padding-top: 28px;
  padding-bottom: 54px;
}
.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}
</style>



// WEBPACK FOOTER //
// src/components/Portal/List.vue